import { configureStore } from "@reduxjs/toolkit";
import cartReducer from "./reducers/cart";
import authReducer from "./reducers/auth";
import { persistReducer, persistStore } from "redux-persist";
import storageHau from "redux-persist/lib/storage"; //đặt tên tuỳ ý
const persistConfig = {
  key: "vietpro",
  storage: storageHau, //bắt buộc phải có key là storage
};
const persistedCartReducer = persistReducer(persistConfig, cartReducer); //tồn tại vĩnh viễn ko mất khi refresh
const persistedAuthReducer = persistReducer(persistConfig, authReducer); //tồn tại vĩnh viễn ko mất khi refresh
export const store = configureStore({
  reducer: {
    cart: persistedCartReducer, //old: 'C' uppercase
    auth: persistedAuthReducer,
  },
});
export const persistorHau = persistStore(store); //đặt tên tuỳ ý
// export const --> lúc gọi phải có dấu {}
export default store; //--> export default lúc gọi ko cần dấu {}, và chỉ được export 1 lần duy nhất

//nhớ bấm @@INIT trong Redux DevTools để bám sát sự cập nhật
